import ModalSelectFieldsRelatorio from "components/ModalSelectFieldsRelatorio/index";
import {
  RelatorioReceitasFields,
  fieldsRelatorioReceitasOptions,
} from "core/features/relatorios/typings";
import OpcoesSearch from "./components/OpcoesSearch";
import { AssinaturasItem } from "components/Relatorio/FormAssinaturas";

interface ExportMenuReceitasProps {
  visible: boolean;
  onClose: () => void;
  onExportPdf: (
    selectedFields: RelatorioReceitasFields[],
    assinaturas?: AssinaturasItem[]
  ) => any;
  onExportExcel: (selectedFields: RelatorioReceitasFields[]) => any;
  setExportType: (type: { type: "pdf" | "excel" } | undefined) => any;
  exportType: { type: "pdf" | "excel" } | undefined;
}

export default function ExportMenuReceitas({
  visible,
  onClose,
  onExportPdf,
  onExportExcel,
  setExportType,
  exportType,
}: ExportMenuReceitasProps) {
  return (
    <>
      <OpcoesSearch
        onExportPdf={() => {
          setExportType({ type: "pdf" });
        }}
        onExportarXlsx={() => {
          setExportType({ type: "excel" });
        }}
        onImprimir={() => ""}
      />

      <ModalSelectFieldsRelatorio
        visible={visible}
        onClose={onClose}
        onSubmit={({ fields, assinaturas }) => {
          exportType?.type === "pdf"
            ? onExportPdf(fields, assinaturas)
            : onExportExcel(fields);
          onClose();
        }}
        fields={
          fieldsRelatorioReceitasOptions as {
            label: string;
            value: RelatorioReceitasFields;
          }[]
        }
      />
    </>
  );
}
